/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/pointOfSale/edit/point-of-sale-edit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../../public/upgrade/feature/pointOfSale/point-of-sale.service';
import * as import6 from '../../../../../../public/upgrade/feature/pointOfSale/edit/point-of-sale-validator.service';
import * as import7 from '../../../../../../public/upgrade/core/geo-code.service';
import * as import8 from '@angular/core/src/linker/view_type';
import * as import9 from '@angular/core/src/change_detection/constants';
import * as import10 from '@angular/core/src/linker/component_factory';
import * as import11 from '@angular/http/src/http';
import * as import12 from '../../../../../../public/upgrade/core/alfred.service';
import * as import13 from '@angular/core/src/zone/ng_zone';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '../../../../../../public/upgrade/root/toast/notification.service';
import * as import16 from '@angular/router/src/router';
import * as import17 from '../../../../../../public/upgrade/root/modal/modal.service';
import * as import18 from '../../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import19 from '@angular/forms/src/form_builder';
import * as import20 from '../../../../../../public/upgrade/root/sidebar/sidebar.service';
import * as import21 from '../../../../../../public/upgrade/core/session.service';
import * as import22 from '../../../../../../public/upgrade/core/logger.service';
import * as import23 from '@ngx-translate/core/src/translate.service';
import * as import24 from '../../../../../../public/upgrade/feature/pointOfSale/edit/office-location/office-location.component';
import * as import25 from './office-location/office-location.component.ngfactory';
import * as import26 from '@angular/core/src/linker/view_container';
import * as import27 from '../../../../../../public/upgrade/core/geo_a2.service';
import * as import28 from '../../../../../../public/upgrade/feature/pointOfSale/delivery-instructions/delivery-instructions.component';
import * as import29 from '../delivery-instructions/delivery-instructions.component.ngfactory';
import * as import30 from '../../../../../../public/upgrade/shared/checkbox-container/checkbox-container.component';
import * as import31 from '../../../shared/checkbox-container/checkbox-container.component.ngfactory';
import * as import32 from '@ngx-translate/core/src/translate.pipe';
import * as import33 from '@angular/core/src/change_detection/change_detection_util';
import * as import34 from '../../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import35 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import36 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import37 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import38 from '@angular/core/src/linker/element_ref';
import * as import39 from '@angular/core/src/linker/template_ref';
import * as import40 from '@angular/common/src/directives/ng_for';
import * as import41 from '@angular/common/src/directives/ng_class';
import * as import42 from '../../../../../../public/upgrade/shared/select-container/select-container.component';
import * as import43 from '../../../shared/select-container/select-container.component.ngfactory';
import * as import44 from '../../../../../../public/upgrade/feature/pointOfSale/edit/business-hours/business-hours.component';
import * as import45 from './business-hours/business-hours.component.ngfactory';
import * as import46 from '../../../../../../public/upgrade/feature/pointOfSale/edit/special-attention-hours/special-attention-hours.component';
import * as import47 from './special-attention-hours/special-attention-hours.component.ngfactory';
import * as import48 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import49 from '../../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import50 from '../../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import51 from '../../../../../../public/upgrade/feature/pointOfSale/edit/general-setting/general-setting.component';
import * as import52 from './general-setting/general-setting.component.ngfactory';
import * as import53 from '../../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import54 from '@angular/common/src/directives/ng_if';
import * as import55 from '@angular/forms/src/directives/ng_form';
import * as import56 from '@angular/forms/src/directives/control_container';
import * as import57 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_PointOfSaleEditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PointOfSaleEditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any,p12:any) {
    this._changed = false;
    this.context = new import0.PointOfSaleEditComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11,p12);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PointOfSaleEditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_PointOfSaleEditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.PointOfSaleEditComponent>;
  _PointOfSaleServiceA2_0_3:import5.PointOfSaleServiceA2;
  _PointOfSaleValidatorService_0_4:import6.PointOfSaleValidatorService;
  _PointOfSaleEditComponent_0_5:Wrapper_PointOfSaleEditComponent;
  __GeoCodeService_0_6:import7.GeoCodeService;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PointOfSaleEditComponent_Host0,renderType_PointOfSaleEditComponent_Host,import8.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
  }
  get _GeoCodeService_0_6():import7.GeoCodeService {
    if ((this.__GeoCodeService_0_6 == null)) { (this.__GeoCodeService_0_6 = new import7.GeoCodeService()); }
    return this.__GeoCodeService_0_6;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'point-of-sale-edit',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PointOfSaleEditComponent0(this.viewUtils,this,0,this._el_0);
    this._PointOfSaleServiceA2_0_3 = new import5.PointOfSaleServiceA2(this.injectorGet(import11.Http,this.parentIndex),this.injectorGet(import12.AlfredA2Service,this.parentIndex));
    this._PointOfSaleValidatorService_0_4 = new import6.PointOfSaleValidatorService();
    this._PointOfSaleEditComponent_0_5 = new Wrapper_PointOfSaleEditComponent(this._PointOfSaleServiceA2_0_3,this.injectorGet(import13.NgZone,this.parentIndex),this.injectorGet(import14.ActivatedRoute,this.parentIndex),this.injectorGet(import15.NotificationService,this.parentIndex),this.injectorGet(import16.Router,this.parentIndex),this.injectorGet(import17.ModalService,this.parentIndex),this.injectorGet(import18.LoadingWheelService,this.parentIndex),this.injectorGet(import19.FormBuilder,this.parentIndex),this.injectorGet(import20.SidebarService,this.parentIndex),this._PointOfSaleValidatorService_0_4,this.injectorGet(import21.SessionService,this.parentIndex),this.injectorGet(import22.LoggerService,this.parentIndex),this.injectorGet(import23.TranslateService,this.parentIndex));
    this.compView_0.create(this._PointOfSaleEditComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import10.ComponentRef_<any>(0,this,this._el_0,this._PointOfSaleEditComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.PointOfSaleServiceA2) && (0 === requestNodeIndex))) { return this._PointOfSaleServiceA2_0_3; }
    if (((token === import6.PointOfSaleValidatorService) && (0 === requestNodeIndex))) { return this._PointOfSaleValidatorService_0_4; }
    if (((token === import0.PointOfSaleEditComponent) && (0 === requestNodeIndex))) { return this._PointOfSaleEditComponent_0_5.context; }
    if (((token === import7.GeoCodeService) && (0 === requestNodeIndex))) { return this._GeoCodeService_0_6; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PointOfSaleEditComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PointOfSaleEditComponentNgFactory:import10.ComponentFactory<import0.PointOfSaleEditComponent> = new import10.ComponentFactory<import0.PointOfSaleEditComponent>('point-of-sale-edit',View_PointOfSaleEditComponent_Host0,import0.PointOfSaleEditComponent);
const styles_PointOfSaleEditComponent:any[] = ([] as any[]);
class View_PointOfSaleEditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import24.OfficeLocationComponent>;
  _GeoCodeService_2_3:import7.GeoCodeService;
  _OfficeLocationComponent_2_4:import25.Wrapper_OfficeLocationComponent;
  __PointOfSaleServiceA2_2_5:import5.PointOfSaleServiceA2;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent1,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  get _PointOfSaleServiceA2_2_5():import5.PointOfSaleServiceA2 {
    if ((this.__PointOfSaleServiceA2_2_5 == null)) { (this.__PointOfSaleServiceA2_2_5 = new import5.PointOfSaleServiceA2(this.parentView.parentView.injectorGet(import11.Http,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import12.AlfredA2Service,this.parentView.parentIndex))); }
    return this.__PointOfSaleServiceA2_2_5;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'office-location',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import25.View_OfficeLocationComponent0(this.viewUtils,this,2,this._el_2);
    this._GeoCodeService_2_3 = new import7.GeoCodeService();
    this._OfficeLocationComponent_2_4 = new import25.Wrapper_OfficeLocationComponent(this.parentView.parentView.injectorGet(import13.NgZone,this.parentView.parentIndex),this._GeoCodeService_2_3,this.parentView.parentView.injectorGet(import27.GeoServiceA2,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import22.LoggerService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import23.TranslateService,this.parentView.parentIndex),this.compView_2.ref);
    this._text_3 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_2.create(this._OfficeLocationComponent_2_4.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import7.GeoCodeService) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._GeoCodeService_2_3; }
    if (((token === import24.OfficeLocationComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._OfficeLocationComponent_2_4.context; }
    if (((token === import5.PointOfSaleServiceA2) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._PointOfSaleServiceA2_2_5; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.subject;
    this._OfficeLocationComponent_2_4.check_subject(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.dto;
    this._OfficeLocationComponent_2_4.check_dto(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.isEditing;
    this._OfficeLocationComponent_2_4.check_isEditing(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.errors;
    this._OfficeLocationComponent_2_4.check_errors(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.errorMessages;
    this._OfficeLocationComponent_2_4.check_errorMessages(currVal_2_0_4,throwOnChange,false);
    this._OfficeLocationComponent_2_4.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._OfficeLocationComponent_2_4.context.ngAfterViewInit(); }
      this._OfficeLocationComponent_2_4.context.ngAfterViewChecked();
    }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._OfficeLocationComponent_2_4.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import28.DeliveryInstructionsComponent>;
  _DeliveryInstructionsComponent_2_3:import29.Wrapper_DeliveryInstructionsComponent;
  _text_3:any;
  _text_4:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent2,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'delivery-instructions',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import29.View_DeliveryInstructionsComponent0(this.viewUtils,this,2,this._el_2);
    this._DeliveryInstructionsComponent_2_3 = new import29.Wrapper_DeliveryInstructionsComponent(this.parentView.parentView.injectorGet(import22.LoggerService,this.parentView.parentIndex));
    this._text_3 = this.renderer.createText((null as any),'\n                    ',(null as any));
    this.compView_2.create(this._DeliveryInstructionsComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.DeliveryInstructionsComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._DeliveryInstructionsComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.errors;
    this._DeliveryInstructionsComponent_2_3.check_errors(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.errorMessages;
    this._DeliveryInstructionsComponent_2_3.check_errorMessages(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.dto;
    this._DeliveryInstructionsComponent_2_3.check_dto(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.countryId;
    this._DeliveryInstructionsComponent_2_3.check_countryId(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = true;
    this._DeliveryInstructionsComponent_2_3.check_hasOtherDeliveryMessage(currVal_2_0_4,throwOnChange,false);
    const currVal_2_0_5:any = this.parentView.context.enabledCity;
    this._DeliveryInstructionsComponent_2_3.check_enabledCity(currVal_2_0_5,throwOnChange,false);
    const currVal_2_0_6:any = this.parentView.context.isPointOfSale;
    this._DeliveryInstructionsComponent_2_3.check_isPointOfSale(currVal_2_0_6,throwOnChange,false);
    this._DeliveryInstructionsComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import30.CheckboxContainerComponent>;
  _CheckboxContainerComponent_2_3:import31.Wrapper_CheckboxContainerComponent;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_7:any;
  _pipe_translate_0:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent4,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_7 = import33.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm ellipsisText'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import31.View_CheckboxContainerComponent0(this.viewUtils,this,2,this._el_2);
    this._CheckboxContainerComponent_2_3 = new import31.Wrapper_CheckboxContainerComponent();
    this._text_3 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_2.create(this._CheckboxContainerComponent_2_3.context);
    this._text_4 = this.renderer.createText(this._el_0,'\n                                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this._CheckboxContainerComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),false,true);
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import30.CheckboxContainerComponent) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 3)))) { return this._CheckboxContainerComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import33.ValueUnwrapper();
    const currVal_2_0_0:any = 'PAYMENTS';
    this._CheckboxContainerComponent_2_3.check_name(currVal_2_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_2_0_1:any = valUnwrapper.unwrap(this._pipe_translate_0.transform(((this.context.$implicit == null)? (null as any): this.context.$implicit.description)));
    this._CheckboxContainerComponent_2_3.check_label(currVal_2_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_2_0_2:any = 'sm';
    this._CheckboxContainerComponent_2_3.check_size(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.parentView.context.dto.paymentMethods[this.context.$implicit.code];
    this._CheckboxContainerComponent_2_3.check_model(currVal_2_0_3,throwOnChange,false);
    this._CheckboxContainerComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_7:any = this.context.$implicit.code;
    if (import3.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setElementProperty(this._el_2,'value',currVal_7);
      this._expr_7 = currVal_7;
    }
    this.compView_2.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_2_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._CheckboxContainerComponent_2_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.parentView.context.dto.paymentMethods[this.context.$implicit.code] = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import34.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _vc_17:import26.ViewContainer;
  _TemplateRef_17_5:any;
  _NgFor_17_6:import35.Wrapper_NgFor;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  compView_21:import1.AppView<import30.CheckboxContainerComponent>;
  _CheckboxContainerComponent_21_3:import31.Wrapper_CheckboxContainerComponent;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _map_37:any;
  /*private*/ _expr_38:any;
  _pipe_translate_0:import32.TranslatePipe;
  _pipe_translate_1:import32.TranslatePipe;
  /*private*/ _expr_41:any;
  _pipe_translate_2:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent3,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._map_37 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-invalid': p0};
    });
    this._expr_38 = import33.UNINITIALIZED;
    this._expr_41 = import33.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-validation -lg -top-left'),(null as any));
    this._NgClass_2_3 = new import34.Wrapper_NgClass(this.parentView.parentView.injectorGet(import36.IterableDiffers,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import37.KeyValueDiffers,this.parentView.parentIndex),new import38.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n\n                    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','eva-3-panel-info -eva-3-bc-white','qadata','paymentMethods'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n\n                        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'',(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                            ',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n                        ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n\n                            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_15,(null as any));
    this._vc_17 = new import26.ViewContainer(17,15,this,this._anchor_17);
    this._TemplateRef_17_5 = new import39.TemplateRef_(this,17,this._anchor_17);
    this._NgFor_17_6 = new import35.Wrapper_NgFor(this._vc_17.vcRef,this._TemplateRef_17_5,this.parentView.parentView.injectorGet(import36.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_18 = this.renderer.createText(this._el_15,'\n                                ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_15,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                                    ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'checkbox-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_21 = new import31.View_CheckboxContainerComponent0(this.viewUtils,this,21,this._el_21);
    this._CheckboxContainerComponent_21_3 = new import31.Wrapper_CheckboxContainerComponent();
    this._text_22 = this.renderer.createText((null as any),'\n                                    ',(null as any));
    this.compView_21.create(this._CheckboxContainerComponent_21_3.context);
    this._text_23 = this.renderer.createText(this._el_19,'\n                                ',(null as any));
    this._text_24 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._text_25 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_2,'span',new import3.InlineArray2(2,'class','validation-msg '),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_2,'\n\n                    ',(null as any));
    this._text_30 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_21,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_21));
    this._CheckboxContainerComponent_21_3.subscribe(this,this.eventHandler(this.handleEvent_21),false,true);
    this._pipe_translate_1 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_2 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._text_30
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import39.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import40.NgFor) && (17 === requestNodeIndex))) { return this._NgFor_17_6.context; }
    if (((token === import30.CheckboxContainerComponent) && ((21 <= requestNodeIndex) && (requestNodeIndex <= 22)))) { return this._CheckboxContainerComponent_21_3.context; }
    if (((token === import41.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import33.ValueUnwrapper();
    const currVal_2_0_0:any = 'eva-3-validation -lg -top-left';
    this._NgClass_2_3.check_klass(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this._map_37(!!this.parentView.context.errors['posPaymentMethods']);
    this._NgClass_2_3.check_ngClass(currVal_2_0_1,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_17_0_0:any = this.parentView.context.data.paymentMethods;
    this._NgFor_17_6.check_ngForOf(currVal_17_0_0,throwOnChange,false);
    this._NgFor_17_6.ngDoCheck(this,this._anchor_17,throwOnChange);
    const currVal_21_0_0:any = 'CASH';
    this._CheckboxContainerComponent_21_3.check_name(currVal_21_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_21_0_1:any = valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.paymentOptions.PAY_IN_CASH'));
    this._CheckboxContainerComponent_21_3.check_label(currVal_21_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_21_0_2:any = 'sm';
    this._CheckboxContainerComponent_21_3.check_size(currVal_21_0_2,throwOnChange,false);
    const currVal_21_0_3:any = this.parentView.context.dto.payInCash;
    this._CheckboxContainerComponent_21_3.check_model(currVal_21_0_3,throwOnChange,false);
    this._CheckboxContainerComponent_21_3.ngDoCheck(this,this._el_21,throwOnChange);
    this._vc_17.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_38:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.PAYMENT_OPTIONS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_38,currVal_38))) {
      this.renderer.setText(this._text_11,currVal_38);
      this._expr_38 = currVal_38;
    }
    valUnwrapper.reset();
    const currVal_41:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform(this.parentView.context.errorMessages['posPaymentMethods'])),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_41,currVal_41))) {
      this.renderer.setText(this._text_28,currVal_41);
      this._expr_41 = currVal_41;
    }
    this.compView_21.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._CheckboxContainerComponent_21_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this._vc_17.destroyNestedViews();
    this.compView_21.destroy();
    this._CheckboxContainerComponent_21_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 17)) { return new View_PointOfSaleEditComponent4(this.viewUtils,this,17,this._anchor_17,this._vc_17); }
    return (null as any);
  }
  handleEvent_21(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto.payInCash = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  compView_20:import1.AppView<import42.SelectContainerComponent>;
  _SelectContainerComponent_20_3:import43.Wrapper_SelectContainerComponent;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  /*private*/ _expr_28:any;
  _pipe_translate_0:import32.TranslatePipe;
  /*private*/ _expr_30:any;
  _pipe_translate_1:import32.TranslatePipe;
  _pipe_translate_2:import32.TranslatePipe;
  _pipe_translate_3:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent5,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_28 = import33.UNINITIALIZED;
    this._expr_30 = import33.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n                                ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_6,'p',new import3.InlineArray2(2,'class','-h6 -eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'',(null as any));
    this._text_13 = this.renderer.createText(this._el_6,'\n                            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_4,'\n                        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n\n                        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                            ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-6 -sm-12 -eva-3-pt-sm'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                                ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_18,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_20 = new import43.View_SelectContainerComponent0(this.viewUtils,this,20,this._el_20);
    this._SelectContainerComponent_20_3 = new import43.Wrapper_SelectContainerComponent();
    this._text_21 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_20.create(this._SelectContainerComponent_20_3.context);
    this._text_22 = this.renderer.createText(this._el_18,'\n                            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_16,'\n                        ',(null as any));
    this._text_24 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_25 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_20));
    this._SelectContainerComponent_20_3.subscribe(this,this.eventHandler(this.handleEvent_20),false,true);
    this._pipe_translate_2 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import42.SelectContainerComponent) && ((20 <= requestNodeIndex) && (requestNodeIndex <= 21)))) { return this._SelectContainerComponent_20_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import33.ValueUnwrapper();
    const currVal_20_0_0:any = 'kms';
    this._SelectContainerComponent_20_3.check_id(currVal_20_0_0,throwOnChange,false);
    const currVal_20_0_1:any = 'posKms';
    this._SelectContainerComponent_20_3.check_name(currVal_20_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_20_0_2:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('pointOfSale.KM_LIMIT'));
    this._SelectContainerComponent_20_3.check_label(currVal_20_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_20_0_3:any = 'md';
    this._SelectContainerComponent_20_3.check_size(currVal_20_0_3,throwOnChange,false);
    const currVal_20_0_4:boolean = !!this.parentView.context.errors['posKms'];
    this._SelectContainerComponent_20_3.check_invalid(currVal_20_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_20_0_5:any = valUnwrapper.unwrap(this._pipe_translate_3.transform(this.parentView.context.errorMessages['posKms']));
    this._SelectContainerComponent_20_3.check_invalidText(currVal_20_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_20_0_6:any = this.parentView.context.data.kms;
    this._SelectContainerComponent_20_3.check_list(currVal_20_0_6,throwOnChange,false);
    const currVal_20_0_7:any = this.parentView.context.dto.kms;
    this._SelectContainerComponent_20_3.check_model(currVal_20_0_7,throwOnChange,false);
    this._SelectContainerComponent_20_3.ngDoCheck(this,this._el_20,throwOnChange);
    valUnwrapper.reset();
    const currVal_28:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.KILOMETER_SEGMENTS')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_9,currVal_28);
      this._expr_28 = currVal_28;
    }
    valUnwrapper.reset();
    const currVal_30:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.KILOMETER_INFORMATION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_30,currVal_30))) {
      this.renderer.setText(this._text_12,currVal_30);
      this._expr_30 = currVal_30;
    }
    this.compView_20.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_20_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_20.destroy();
    this._SelectContainerComponent_20_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto.kms = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import44.BusinessHoursComponent>;
  _BusinessHoursComponent_2_3:import45.Wrapper_BusinessHoursComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent6,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'business-hours',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import45.View_BusinessHoursComponent0(this.viewUtils,this,2,this._el_2);
    this._BusinessHoursComponent_2_3 = new import45.Wrapper_BusinessHoursComponent(this.parentView.parentView.injectorGet(import22.LoggerService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import23.TranslateService,this.parentView.parentIndex));
    this.compView_2.create(this._BusinessHoursComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import44.BusinessHoursComponent) && (2 === requestNodeIndex))) { return this._BusinessHoursComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.dto;
    this._BusinessHoursComponent_2_3.check_dto(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.isEditing;
    this._BusinessHoursComponent_2_3.check_isEditing(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.errors;
    this._BusinessHoursComponent_2_3.check_errors(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.errorMessages;
    this._BusinessHoursComponent_2_3.check_errorMessages(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.data;
    this._BusinessHoursComponent_2_3.check_data(currVal_2_0_4,throwOnChange,false);
    this._BusinessHoursComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_PointOfSaleEditComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import46.SpecialAttentionHoursComponent>;
  _SpecialAttentionHoursComponent_2_3:import47.Wrapper_SpecialAttentionHoursComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import26.ViewContainer) {
    super(View_PointOfSaleEditComponent7,renderType_PointOfSaleEditComponent,import8.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'special-attention-hours',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import47.View_SpecialAttentionHoursComponent0(this.viewUtils,this,2,this._el_2);
    this._SpecialAttentionHoursComponent_2_3 = new import47.Wrapper_SpecialAttentionHoursComponent(this.parentView.parentView.injectorGet(import22.LoggerService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import23.TranslateService,this.parentView.parentIndex),this.parentView.parentView.injectorGet(import48.GAService,this.parentView.parentIndex));
    this.compView_2.create(this._SpecialAttentionHoursComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_2));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import46.SpecialAttentionHoursComponent) && (2 === requestNodeIndex))) { return this._SpecialAttentionHoursComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.dto;
    this._SpecialAttentionHoursComponent_2_3.check_dto(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = this.parentView.context.isEditing;
    this._SpecialAttentionHoursComponent_2_3.check_isEditing(currVal_2_0_1,throwOnChange,false);
    const currVal_2_0_2:any = this.parentView.context.errors;
    this._SpecialAttentionHoursComponent_2_3.check_errors(currVal_2_0_2,throwOnChange,false);
    const currVal_2_0_3:any = this.parentView.context.errorMessages;
    this._SpecialAttentionHoursComponent_2_3.check_errorMessages(currVal_2_0_3,throwOnChange,false);
    const currVal_2_0_4:any = this.parentView.context.data;
    this._SpecialAttentionHoursComponent_2_3.check_data(currVal_2_0_4,throwOnChange,false);
    this._SpecialAttentionHoursComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_PointOfSaleEditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_PointOfSaleEditComponent,{});
export class View_PointOfSaleEditComponent0 extends import1.AppView<import0.PointOfSaleEditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _NgForm_4_3:import49.Wrapper_NgForm;
  _ControlContainer_4_4:any;
  _NgControlStatusGroup_4_5:import50.Wrapper_NgControlStatusGroup;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  compView_28:import1.AppView<import51.GeneralSettingComponent>;
  _GeneralSettingComponent_28_3:import52.Wrapper_GeneralSettingComponent;
  _text_29:any;
  _text_30:any;
  _anchor_31:any;
  /*private*/ _vc_31:import26.ViewContainer;
  _TemplateRef_31_5:any;
  _NgIf_31_6:import53.Wrapper_NgIf;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _vc_33:import26.ViewContainer;
  _TemplateRef_33_5:any;
  _NgIf_33_6:import53.Wrapper_NgIf;
  _text_34:any;
  _anchor_35:any;
  /*private*/ _vc_35:import26.ViewContainer;
  _TemplateRef_35_5:any;
  _NgIf_35_6:import53.Wrapper_NgIf;
  _text_36:any;
  _anchor_37:any;
  /*private*/ _vc_37:import26.ViewContainer;
  _TemplateRef_37_5:any;
  _NgIf_37_6:import53.Wrapper_NgIf;
  _text_38:any;
  _anchor_39:any;
  /*private*/ _vc_39:import26.ViewContainer;
  _TemplateRef_39_5:any;
  _NgIf_39_6:import53.Wrapper_NgIf;
  _text_40:any;
  _anchor_41:any;
  /*private*/ _vc_41:import26.ViewContainer;
  _TemplateRef_41_5:any;
  _NgIf_41_6:import53.Wrapper_NgIf;
  _text_42:any;
  _el_43:any;
  _text_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _el_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  _text_61:any;
  /*private*/ _expr_85:any;
  _pipe_translate_0:import32.TranslatePipe;
  /*private*/ _expr_87:any;
  _pipe_translate_1:import32.TranslatePipe;
  /*private*/ _expr_89:any;
  _pipe_translate_2:import32.TranslatePipe;
  /*private*/ _expr_91:any;
  /*private*/ _expr_92:any;
  _pipe_translate_3:import32.TranslatePipe;
  /*private*/ _expr_94:any;
  _pipe_translate_4:import32.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PointOfSaleEditComponent0,renderType_PointOfSaleEditComponent,import8.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import9.ChangeDetectorStatus.CheckAlways);
    this._expr_85 = import33.UNINITIALIZED;
    this._expr_87 = import33.UNINITIALIZED;
    this._expr_89 = import33.UNINITIALIZED;
    this._expr_91 = import33.UNINITIALIZED;
    this._expr_92 = import33.UNINITIALIZED;
    this._expr_94 = import33.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import10.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start points-of-sale'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'form',new import3.InlineArray2(2,'name','posform'),(null as any));
    this._NgForm_4_3 = new import49.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_4_4 = this._NgForm_4_3.context;
    this._NgControlStatusGroup_4_5 = new import50.Wrapper_NgControlStatusGroup(this._ControlContainer_4_4);
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'h2',new import3.InlineArray2(2,'class','eva-3-h2'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_10,'p',new import3.InlineArray2(2,'class','-h6'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_15,'span',new import3.InlineArray2(2,'class','-eva-3-tc-gray-2 -eva-3-mt-sm'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'',(null as any));
    this._text_19 = this.renderer.createText(this._el_15,'\n                            ',(null as any));
    this._el_20 = import3.createRenderElement(this.renderer,this._el_15,'dsp-button',new import3.InlineArray8(6,'class','show-additional-pick-up','size','md','variation','link'),(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'',(null as any));
    this._text_22 = this.renderer.createText(this._el_15,'\n                        ',(null as any));
    this._text_23 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_24 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_25 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'general-setting',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_28 = new import52.View_GeneralSettingComponent0(this.viewUtils,this,28,this._el_28);
    this._GeneralSettingComponent_28_3 = new import52.Wrapper_GeneralSettingComponent(this.parentView.injectorGet(import22.LoggerService,this.parentIndex));
    this.compView_28.create(this._GeneralSettingComponent_28_3.context);
    this._text_29 = this.renderer.createText(this._el_26,'\n                ',(null as any));
    this._text_30 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_31 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_31 = new import26.ViewContainer(31,6,this,this._anchor_31);
    this._TemplateRef_31_5 = new import39.TemplateRef_(this,31,this._anchor_31);
    this._NgIf_31_6 = new import53.Wrapper_NgIf(this._vc_31.vcRef,this._TemplateRef_31_5);
    this._text_32 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_33 = new import26.ViewContainer(33,6,this,this._anchor_33);
    this._TemplateRef_33_5 = new import39.TemplateRef_(this,33,this._anchor_33);
    this._NgIf_33_6 = new import53.Wrapper_NgIf(this._vc_33.vcRef,this._TemplateRef_33_5);
    this._text_34 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_35 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_35 = new import26.ViewContainer(35,6,this,this._anchor_35);
    this._TemplateRef_35_5 = new import39.TemplateRef_(this,35,this._anchor_35);
    this._NgIf_35_6 = new import53.Wrapper_NgIf(this._vc_35.vcRef,this._TemplateRef_35_5);
    this._text_36 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_37 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_37 = new import26.ViewContainer(37,6,this,this._anchor_37);
    this._TemplateRef_37_5 = new import39.TemplateRef_(this,37,this._anchor_37);
    this._NgIf_37_6 = new import53.Wrapper_NgIf(this._vc_37.vcRef,this._TemplateRef_37_5);
    this._text_38 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_39 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_39 = new import26.ViewContainer(39,6,this,this._anchor_39);
    this._TemplateRef_39_5 = new import39.TemplateRef_(this,39,this._anchor_39);
    this._NgIf_39_6 = new import53.Wrapper_NgIf(this._vc_39.vcRef,this._TemplateRef_39_5);
    this._text_40 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._anchor_41 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_41 = new import26.ViewContainer(41,6,this,this._anchor_41);
    this._TemplateRef_41_5 = new import39.TemplateRef_(this,41,this._anchor_41);
    this._NgIf_41_6 = new import53.Wrapper_NgIf(this._vc_41.vcRef,this._TemplateRef_41_5);
    this._text_42 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_44 = this.renderer.createText(this._el_43,'\n                    ',(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_43,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_46 = this.renderer.createText(this._el_45,'\n                        ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_45,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                            ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'dsp-button',new import3.InlineArray8(6,'qadata','save','size','md','variation','primary'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'',(null as any));
    this._text_51 = this.renderer.createText(this._el_47,'\n                            ',(null as any));
    this._el_52 = import3.createRenderElement(this.renderer,this._el_47,'dsp-button',new import3.InlineArray8(6,'qadata','cancel','size','md','variation','link'),(null as any));
    this._text_53 = this.renderer.createText(this._el_52,'',(null as any));
    this._text_54 = this.renderer.createText(this._el_47,'\n                        ',(null as any));
    this._text_55 = this.renderer.createText(this._el_45,'\n                    ',(null as any));
    this._text_56 = this.renderer.createText(this._el_43,'\n                ',(null as any));
    this._text_57 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_58 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_59 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_60 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_61 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_20,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_20));
    this._pipe_translate_2 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_28,new import3.InlineArray2(2,'dtoChange',(null as any)),this.eventHandler(this.handleEvent_28));
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_49,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_49));
    this._pipe_translate_3 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_52,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_52));
    this._pipe_translate_4 = new import32.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._anchor_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._anchor_35,
      this._text_36,
      this._anchor_37,
      this._text_38,
      this._anchor_39,
      this._text_40,
      this._anchor_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._text_60,
      this._text_61
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import51.GeneralSettingComponent) && (28 === requestNodeIndex))) { return this._GeneralSettingComponent_28_3.context; }
    if (((token === import39.TemplateRef) && (31 === requestNodeIndex))) { return this._TemplateRef_31_5; }
    if (((token === import54.NgIf) && (31 === requestNodeIndex))) { return this._NgIf_31_6.context; }
    if (((token === import39.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import54.NgIf) && (33 === requestNodeIndex))) { return this._NgIf_33_6.context; }
    if (((token === import39.TemplateRef) && (35 === requestNodeIndex))) { return this._TemplateRef_35_5; }
    if (((token === import54.NgIf) && (35 === requestNodeIndex))) { return this._NgIf_35_6.context; }
    if (((token === import39.TemplateRef) && (37 === requestNodeIndex))) { return this._TemplateRef_37_5; }
    if (((token === import54.NgIf) && (37 === requestNodeIndex))) { return this._NgIf_37_6.context; }
    if (((token === import39.TemplateRef) && (39 === requestNodeIndex))) { return this._TemplateRef_39_5; }
    if (((token === import54.NgIf) && (39 === requestNodeIndex))) { return this._NgIf_39_6.context; }
    if (((token === import39.TemplateRef) && (41 === requestNodeIndex))) { return this._TemplateRef_41_5; }
    if (((token === import54.NgIf) && (41 === requestNodeIndex))) { return this._NgIf_41_6.context; }
    if (((token === import55.NgForm) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._NgForm_4_3.context; }
    if (((token === import56.ControlContainer) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._ControlContainer_4_4; }
    if (((token === import57.NgControlStatusGroup) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 58)))) { return this._NgControlStatusGroup_4_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import33.ValueUnwrapper();
    this._NgForm_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatusGroup_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_28_0_0:any = this.context.dto;
    this._GeneralSettingComponent_28_3.check_dto(currVal_28_0_0,throwOnChange,false);
    const currVal_28_0_1:any = this.context.errors;
    this._GeneralSettingComponent_28_3.check_errors(currVal_28_0_1,throwOnChange,false);
    const currVal_28_0_2:any = this.context.errorMessages;
    this._GeneralSettingComponent_28_3.check_errorMessages(currVal_28_0_2,throwOnChange,false);
    const currVal_28_0_3:any = this.context.data;
    this._GeneralSettingComponent_28_3.check_data(currVal_28_0_3,throwOnChange,false);
    this._GeneralSettingComponent_28_3.ngDoCheck(this,this._el_28,throwOnChange);
    const currVal_31_0_0:any = (this.context.endLoading && (!this.context.isEditing || ((this.context.isEditing && !!this.context.dto.geoLocation.latitude) && !!this.context.dto.geoLocation.longitude)));
    this._NgIf_31_6.check_ngIf(currVal_31_0_0,throwOnChange,false);
    this._NgIf_31_6.ngDoCheck(this,this._anchor_31,throwOnChange);
    const currVal_33_0_0:any = (this.context.endLoading && (((this.context.dto == null)? (null as any): this.context.dto.destinationType) == 'AIRPORT'));
    this._NgIf_33_6.check_ngIf(currVal_33_0_0,throwOnChange,false);
    this._NgIf_33_6.ngDoCheck(this,this._anchor_33,throwOnChange);
    const currVal_35_0_0:any = this.context.endLoading;
    this._NgIf_35_6.check_ngIf(currVal_35_0_0,throwOnChange,false);
    this._NgIf_35_6.ngDoCheck(this,this._anchor_35,throwOnChange);
    const currVal_37_0_0:any = this.context.endLoading;
    this._NgIf_37_6.check_ngIf(currVal_37_0_0,throwOnChange,false);
    this._NgIf_37_6.ngDoCheck(this,this._anchor_37,throwOnChange);
    const currVal_39_0_0:boolean = !!this.context.endLoading;
    this._NgIf_39_6.check_ngIf(currVal_39_0_0,throwOnChange,false);
    this._NgIf_39_6.ngDoCheck(this,this._anchor_39,throwOnChange);
    const currVal_41_0_0:boolean = !!this.context.endLoading;
    this._NgIf_41_6.check_ngIf(currVal_41_0_0,throwOnChange,false);
    this._NgIf_41_6.ngDoCheck(this,this._anchor_41,throwOnChange);
    this._vc_31.detectChangesInNestedViews(throwOnChange);
    this._vc_33.detectChangesInNestedViews(throwOnChange);
    this._vc_35.detectChangesInNestedViews(throwOnChange);
    this._vc_37.detectChangesInNestedViews(throwOnChange);
    this._vc_39.detectChangesInNestedViews(throwOnChange);
    this._vc_41.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_4_5.checkHost(this,this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_85:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_85,currVal_85))) {
      this.renderer.setText(this._text_13,currVal_85);
      this._expr_85 = currVal_85;
    }
    valUnwrapper.reset();
    const currVal_87:any = import3.inlineInterpolate(1,'\n                                ',valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.EXPLANATION')),'\n                            ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_87,currVal_87))) {
      this.renderer.setText(this._text_18,currVal_87);
      this._expr_87 = currVal_87;
    }
    valUnwrapper.reset();
    const currVal_89:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('pointOfSale.EXPLANATION_2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_89,currVal_89))) {
      this.renderer.setText(this._text_21,currVal_89);
      this._expr_89 = currVal_89;
    }
    const currVal_91:boolean = !this.context.endLoading;
    if (import3.checkBinding(throwOnChange,this._expr_91,currVal_91)) {
      this.renderer.setElementProperty(this._el_26,'hidden',currVal_91);
      this._expr_91 = currVal_91;
    }
    valUnwrapper.reset();
    const currVal_92:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_92,currVal_92))) {
      this.renderer.setText(this._text_50,currVal_92);
      this._expr_92 = currVal_92;
    }
    valUnwrapper.reset();
    const currVal_94:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_94,currVal_94))) {
      this.renderer.setText(this._text_53,currVal_94);
      this._expr_94 = currVal_94;
    }
    this.compView_28.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_31.destroyNestedViews();
    this._vc_33.destroyNestedViews();
    this._vc_35.destroyNestedViews();
    this._vc_37.destroyNestedViews();
    this._vc_39.destroyNestedViews();
    this._vc_41.destroyNestedViews();
    this.compView_28.destroy();
    this._NgForm_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 31)) { return new View_PointOfSaleEditComponent1(this.viewUtils,this,31,this._anchor_31,this._vc_31); }
    if ((nodeIndex == 33)) { return new View_PointOfSaleEditComponent2(this.viewUtils,this,33,this._anchor_33,this._vc_33); }
    if ((nodeIndex == 35)) { return new View_PointOfSaleEditComponent3(this.viewUtils,this,35,this._anchor_35,this._vc_35); }
    if ((nodeIndex == 37)) { return new View_PointOfSaleEditComponent5(this.viewUtils,this,37,this._anchor_37,this._vc_37); }
    if ((nodeIndex == 39)) { return new View_PointOfSaleEditComponent6(this.viewUtils,this,39,this._anchor_39,this._vc_39); }
    if ((nodeIndex == 41)) { return new View_PointOfSaleEditComponent7(this.viewUtils,this,41,this._anchor_41,this._vc_41); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_4_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_20(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.goToAdditionals()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_28(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'dtoChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_49(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_52(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/edit/point-of-sale-edit.component.ngfactory.ts